<script setup lang="ts">
import type { StrapiBlockInlineLink } from '@nimbus/types'
import { omit } from 'es-toolkit'
import { getQuery } from 'ufo'
import type { NuxtLinkProps } from '#app'
import { computed } from '#imports'

const props = defineProps<StrapiBlockInlineLink>()

function getTo() {
    if (typeof props.url === 'string') {
        // Strapi does not allow starting urls with ?, which makes it impossible to write query params correctly.
        // This tweak allows it to start with /?, but strips the /, so it updates query params for the current route
        if (props.url.startsWith('/?')) {
            const query = getQuery(props.url)

            return {
                query
            }
        }
    }

    return props.url
}

const linkProps = computed(() => {
    const to = getTo()

    const value: NuxtLinkProps = {
        ...omit(props, ['type', 'children', 'url', 'noPrefetch']),
        to,
        external: typeof to === 'string',
        ...(props.newTabLinks && { target: '_blank' })
    }

    return value
})
</script>

<template>
    <NuxtLink v-bind="linkProps" tabindex="-1">
        <NimbusStrapiBlockRenderer :content="children" />
    </NuxtLink>
</template>

<style scoped lang="scss">
</style>
